import React, { Fragment, useState } from "react";
import { Card, Row, Col, Progress, Tabs } from "antd";
import { isEmpty } from "lodash";
import moment from "moment";
// Global Styles
import {
  KPITitleText,
  KpiSubText,
  KpiFlightDate,
  TabText,
} from "../../../../../shared/globalStyling/styledText";
import { ExtraInfo } from "../attribution/components";
import {
  WalkinsByDateCard,
  WalkinChartByDate,
  VisitsByDayOfWeekCard,
  HeatMapCard,
  WalkinByLocation,
  BreakdownByCreative,
  TotalVisitsChartCard,
} from "./components";
import {
  getVisitsByDayOfWeek,
  cumulativeResponseData,
  walkinResponseDataByDate,
  mergeDiplayToAttributionCreatives,
} from "./utils/dataProcessing";
import {
  formatWholeNumber,
  formatNumber4SigFig,
  formatWholeNumberNaN,
} from "../../../../../../core/utils/campaigns";
import { ArrowRightOutlined } from "@ant-design/icons";
import { styles } from "./AttributionStyles.style";
import VisitByDateCardV2 from "./components/VisitByDateCardV2";
import VisitByDayOfWeekCardV2 from "./components/VisitByDayOfWeekCardV2";
import VisitByHourOfDayCardV2 from "./components/VisitByHourOfDayCardV2";
import VisitByFrequencyCardV2 from "./components/VisitByFrequencyCardV2";
import Text from "antd/lib/typography/Text";

const AttributionReport = ({
  campaign,
  chartData: {
    walkinByLocationComplete,
    walkinByCreative,
    walkinByLineItem,
    walkInByDayOfWeek,
    walkInByDate,
    creatives,
    totalWalkIns,
    uniqueDevices,
    chartsBuilt,
    observationsByGeoTarget,
    onspotWalkInReports,
  },
  chartData,
  attributionLocations,
  byWalkinRangeDate,
  setByWalkinRangeDate,
  dataWalkinRangeDate,
  setDataWalkinRangeDate,
  byWalkinRangeDateHead,
  setByWalkinRangeDateHead,
  dataWalkinRangeDateHead,
  setDataWalkinRangeDateHead,
  amplify,
}) => {
  let getCount = "";
  let getUnique = "";

  const { startDate, endDate, aggregateData, type } = campaign;
  const getByProviderCreatives =
    chartData &&
    chartData.byProvider &&
    chartData.byProvider.liquidm &&
    chartData.byProvider.liquidm.creatives;

  const getProgress = () => {
    const total = () => {
      var a = moment(endDate);
      var b = moment(startDate);
      const total = a.diff(b, "days");
      return total;
    };

    const progress = () => {
      var a = moment();
      var b = moment(startDate);
      const progress = a.diff(b, "days");
      return progress;
    };

    const totaldays = total();
    const progressDays = progress();
    if (progressDays > totaldays || progressDays === totaldays) {
      return 100;
    }

    // % increase = Increase ÷ Original Number × 100.
    const daysleft = totaldays - progressDays;
    const daysin = totaldays - daysleft;
    const result = (daysin / totaldays) * 100;
    return Math.floor(result);
  };

  const currentposition = getProgress();

  const impressions =
    isEmpty(campaign.aggregateData) ||
    isEmpty(campaign.aggregateData.overallData)
      ? 0
      : campaign.aggregateData.overallData.aggImpressions;

  if (!isEmpty(dataWalkinRangeDateHead)) {
    getCount = dataWalkinRangeDateHead.reduce((n, { count }) => n + count, 0);
    getUnique = dataWalkinRangeDateHead.reduce(
      (n, { unique }) => n + unique,
      0
    );
  }

  const [walkInsTabIndex, setWalkInsTabIndex] = useState("legacy");

  return (
    <Fragment>
      {!isEmpty(chartData) &&
      !isEmpty(chartData.onspotWalkInReports) &&
      amplify ? (
        <Tabs
          destroyInactiveTabPane={true}
          activeKey={walkInsTabIndex}
          onChange={activeKey => {
            setWalkInsTabIndex(activeKey);
          }}
        >
          <Tabs.TabPane tab={<TabText text={"Walk Ins"} />} key="legacy">
            <LegacyReport
              styles={styles}
              startDate={startDate}
              endDate={endDate}
              currentposition={currentposition}
              aggregateData={aggregateData}
              totalWalkIns={totalWalkIns}
              dataWalkinRangeDateHead={dataWalkinRangeDateHead}
              getCount={getCount}
              uniqueDevices={uniqueDevices}
              getUnique={getUnique}
              walkinByLocationComplete={walkinByLocationComplete}
              walkInByDayOfWeek={walkInByDayOfWeek}
              walkInByDate={walkInByDate}
              byWalkinRangeDateHead={byWalkinRangeDateHead}
              setByWalkinRangeDate={setByWalkinRangeDate}
              setByWalkinRangeDateHead={setByWalkinRangeDateHead}
              setDataWalkinRangeDateHead={setDataWalkinRangeDateHead}
              attributionLocations={attributionLocations}
              observationsByGeoTarget={observationsByGeoTarget}
              byWalkinRangeDate={byWalkinRangeDate}
              dataWalkinRangeDate={dataWalkinRangeDate}
              setDataWalkinRangeDate={setDataWalkinRangeDate}
              chartsBuilt={chartsBuilt}
              impressions={impressions}
              type={type}
              walkinByCreative={walkinByCreative}
              creatives={creatives}
              getByProviderCreatives={getByProviderCreatives}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab={<TabText text={"Walk Ins V2"} />} key="onspot">
            <WalkInReportV2
              styles={styles}
              onspotWalkInReports={onspotWalkInReports}
            />
          </Tabs.TabPane>
        </Tabs>
      ) : (
        <LegacyReport
          styles={styles}
          startDate={startDate}
          endDate={endDate}
          currentposition={currentposition}
          aggregateData={aggregateData}
          totalWalkIns={totalWalkIns}
          dataWalkinRangeDateHead={dataWalkinRangeDateHead}
          getCount={getCount}
          uniqueDevices={uniqueDevices}
          getUnique={getUnique}
          walkinByLocationComplete={walkinByLocationComplete}
          walkInByDayOfWeek={walkInByDayOfWeek}
          walkInByDate={walkInByDate}
          byWalkinRangeDateHead={byWalkinRangeDateHead}
          setByWalkinRangeDate={setByWalkinRangeDate}
          setByWalkinRangeDateHead={setByWalkinRangeDateHead}
          setDataWalkinRangeDateHead={setDataWalkinRangeDateHead}
          attributionLocations={attributionLocations}
          observationsByGeoTarget={observationsByGeoTarget}
          byWalkinRangeDate={byWalkinRangeDate}
          dataWalkinRangeDate={dataWalkinRangeDate}
          setDataWalkinRangeDate={setDataWalkinRangeDate}
          chartsBuilt={chartsBuilt}
          impressions={impressions}
          type={type}
          walkinByCreative={walkinByCreative}
          creatives={creatives}
          getByProviderCreatives={getByProviderCreatives}
        />
      )}
    </Fragment>
  );
};

const LegacyReport = ({
  styles,
  startDate,
  endDate,
  currentposition,
  aggregateData,
  totalWalkIns,
  dataWalkinRangeDateHead,
  getCount,
  uniqueDevices,
  getUnique,
  walkinByLocationComplete,
  walkInByDayOfWeek,
  walkInByDate,
  byWalkinRangeDateHead,
  setByWalkinRangeDate,
  setByWalkinRangeDateHead,
  setDataWalkinRangeDateHead,
  attributionLocations,
  observationsByGeoTarget,
  byWalkinRangeDate,
  dataWalkinRangeDate,
  setDataWalkinRangeDate,
  chartsBuilt,
  impressions,
  type,
  walkinByCreative,
  creatives,
  getByProviderCreatives,
}) => {
  return (
    <Fragment>
      <Row type="flex" style={styles.overviewBar}>
        <Col xl={8} lg={8} xs={24}>
          <Card
            style={{ height: "10em", borderRight: 0, borderTop: 0 }}
            bodyStyle={{ borderLeft: 0 }}
          >
            <div style={styles.title}>
              <KPITitleText text={"Flight Dates"} />
              <span>
                <ExtraInfo
                  title={
                    "Flight Dates refers to the Start & End Dates of the individual campaign"
                  }
                  placement={"top"}
                />
              </span>
            </div>
            <div style={styles.datesContainer}>
              <div style={styles.dates}>
                <KpiFlightDate
                  text={startDate ? moment(startDate).format("MM/DD/YYYY") : ""}
                />
              </div>
              <div>
                <ArrowRightOutlined style={{ color: "#636363" }} />
              </div>
              <div style={styles.dates}>
                <KpiFlightDate
                  text={endDate ? moment(endDate).format("MM/DD/YYYY") : ""}
                />
              </div>
            </div>
            <Progress
              showInfo={false}
              percent={currentposition}
              status={currentposition !== 100 ? "active" : "normal"}
              strokeColor={"#636363"}
            />
          </Card>
        </Col>
        <Col xl={4} lg={4} xs={24}>
          <Card
            style={{ height: "10em", borderRight: 0, borderTop: 0 }}
            bodyStyle={{
              borderLeft: 0,
              paddingRight: "1rem",
              paddingLeft: "1rem",
            }}
          >
            <div style={styles.title}>
              <KPITitleText text={"Impressions"} />
            </div>
            <KpiSubText
              text={
                aggregateData
                  ? ` ${formatWholeNumber(
                      aggregateData.overallData.aggImpressions
                    )}`
                  : " N/A"
              }
            />
          </Card>
        </Col>
        <Col xl={4} lg={4} xs={24}>
          <Card
            style={{
              height: "10em",
              borderRight: 0,
              borderTop: 0,
            }}
            bodyStyle={{ paddingRight: "1rem", paddingLeft: "1rem" }}
          >
            <div style={styles.title}>
              <KPITitleText text={"Total Walk-Ins"} />
              <span>
                <ExtraInfo
                  title={
                    "The total device IDs captured via geofencing during the defined date range"
                  }
                  placement={"top"}
                />
              </span>
            </div>
            <KpiSubText
              text={
                totalWalkIns
                  ? isEmpty(dataWalkinRangeDateHead)
                    ? `${formatWholeNumber(totalWalkIns)}`
                    : getCount
                  : "0"
              }
            />
          </Card>
        </Col>
        <Col xl={4} lg={4} xs={24}>
          <Card
            style={{ height: "10em", borderRight: 0, borderTop: 0 }}
            bodyStyle={{
              borderLeft: 0,
              paddingRight: "1rem",
              paddingLeft: "1rem",
            }}
          >
            <div style={styles.title}>
              <KPITitleText text={"Unique Walks-Ins"} />
              <span>
                <ExtraInfo
                  title={
                    "The unique device IDs captured via geofencing during the defined date range"
                  }
                  placement={"top"}
                />
              </span>
            </div>
            <KpiSubText
              text={
                uniqueDevices
                  ? isEmpty(dataWalkinRangeDateHead)
                    ? ` ${formatWholeNumber(uniqueDevices)}`
                    : getUnique
                  : "0"
              }
            />
          </Card>
        </Col>
        <Col xl={4} lg={4} xs={24}>
          <Card
            style={{ height: "10em", borderTop: 0 }}
            bodyStyle={{
              borderLeft: 0,
              paddingRight: "1rem",
              paddingLeft: "1rem",
            }}
          >
            <div style={styles.title}>
              <KPITitleText text={"Walk-In Rate"} />
              <span>
                <ExtraInfo
                  title={"The rate of Walk Ins over the defined date range"}
                  placement={"topRight"}
                />
              </span>
            </div>
            <KpiSubText
              text={
                totalWalkIns
                  ? ` ${formatNumber4SigFig(
                      (totalWalkIns /
                        aggregateData.overallData.aggImpressions) *
                        100
                    )}%`
                  : 0
              }
            />
          </Card>
        </Col>
      </Row>

      {!isEmpty(walkinByLocationComplete) &&
      !isEmpty(walkInByDayOfWeek) &&
      !isEmpty(walkInByDate) ? (
        <div>
          {walkInByDate.length > 1 && (
            <Row style={{ marginBottom: "20px" }}>
              <Col xs={24}>
                <WalkinChartByDate
                  byWalkinRangeDate={byWalkinRangeDateHead}
                  setByWalkinRangeDate={setByWalkinRangeDateHead}
                  dataWalkinRangeDate={dataWalkinRangeDateHead}
                  setDataWalkinRangeDate={setDataWalkinRangeDateHead}
                  flightDates={{
                    start: moment(startDate).format("MMMM DD"),
                    end: moment().isBefore(endDate)
                      ? moment().format("MMMM DD")
                      : moment(endDate).format("MMMM DD"),
                  }}
                  data={
                    !isEmpty(walkInByDate)
                      ? walkinResponseDataByDate(walkInByDate)
                      : []
                  }
                />
              </Col>
            </Row>
          )}
          <Row gutter={30} style={{ marginTop: "2.5%" }}>
            <Col xl={12} lg={12} xs={24}>
              <Card bodyStyle={{ padding: 0 }}>
                <HeatMapCard
                  latLngs={
                    !isEmpty(walkinByLocationComplete)
                      ? walkinByLocationComplete
                      : []
                  }
                  geoTargets={attributionLocations}
                  observationsByGeoTarget={observationsByGeoTarget}
                />
              </Card>
            </Col>
            <Col xl={12} lg={12} xs={24}>
              <VisitsByDayOfWeekCard
                flightDates={{
                  start: moment(startDate).format("MMMM DD"),
                  end: moment().isBefore(endDate)
                    ? moment().format("MMMM DD")
                    : moment(endDate).format("MMMM DD"),
                }}
                data={getVisitsByDayOfWeek(walkInByDayOfWeek)}
                counts={
                  !isEmpty(walkInByDayOfWeek)
                    ? walkInByDayOfWeek.map(el => el.COUNT)
                    : []
                }
              />
            </Col>
          </Row>
          <Row gutter={30} style={{ marginTop: "2.5%" }}>
            <Col xl={12} lg={12} xs={24}>
              <WalkinsByDateCard
                byWalkinRangeDate={byWalkinRangeDate}
                setByWalkinRangeDate={setByWalkinRangeDate}
                dataWalkinRangeDate={dataWalkinRangeDate}
                setDataWalkinRangeDate={setDataWalkinRangeDate}
                flightDates={{
                  start: moment(startDate).format("MMMM DD"),
                  end: moment().isBefore(endDate)
                    ? moment().format("MMMM DD")
                    : moment(endDate).format("MMMM DD"),
                }}
                data={
                  !isEmpty(walkInByDate)
                    ? cumulativeResponseData(walkInByDate)
                    : []
                }
              />
            </Col>
            <Col xl={12} lg={12} xs={24}>
              <TotalVisitsChartCard
                flightDates={{
                  start: moment(startDate).format("MMMM DD"),
                  end: moment().isBefore(endDate)
                    ? moment().format("MMMM DD")
                    : moment(endDate).format("MMMM DD"),
                }}
                uniqueResponses={uniqueDevices}
                totalVisits={totalWalkIns}
                totalAndUniqueVisitsData={walkInByDate}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "2.5%" }}>
            <Col span={24}>
              <WalkinByLocation
                attributionUpdatedOn={chartsBuilt}
                data={
                  !isEmpty(walkinByLocationComplete)
                    ? walkinByLocationComplete
                    : []
                }
                walkIns={totalWalkIns}
                impressions={impressions}
              />
            </Col>
          </Row>
        </div>
      ) : null}

      {type !== "OOH" && !isEmpty(walkinByCreative) && (
        <Row style={{ marginTop: "2.5%" }}>
          <Col span={24}>
            <BreakdownByCreative
              data={
                !isEmpty(walkinByCreative)
                  ? mergeDiplayToAttributionCreatives(
                      walkinByCreative,
                      !isEmpty(creatives) ? creatives : getByProviderCreatives
                    )
                  : []
              }
            />
          </Col>
        </Row>
      )}
      {/* {type !== "OOH" && !isEmpty(walkinByLineItem) && (
  <Row style={{ marginTop: "2.5%" }}>
    <Col span={24}>
      <BreakdownByLineItem
        data={
          !isEmpty(walkinByLineItem)
            ? getWalkinByLineItem(walkinByLineItem, campaign)
            : []
        }
        walkIns={totalWalkIns}
        impressions={impressions}
      />
    </Col>
  </Row>
)} */}
    </Fragment>
  );
};

const WalkInReportV2 = ({
  styles,
  onspotWalkInReports: {
    geoStartDate,
    geoEndDate,
    attribution,
    observations,
    updatedAt,
  },
}) => {
  const walkInsCount = (attribution && attribution.count) || 0;
  const walkInsFrequency = attribution && attribution.frequency;
  const walkInsDayOfWeek = attribution && attribution.dayOfWeek;
  const walkInsHourOfDay = attribution && attribution.hourOfDay;

  const uniqueObservationsCount = observations && observations.uniqueCount;
  const nonUniqueObservationsCount =
    observations && observations.nonUniqueCount;
  const observationsByDate = observations && observations.byDate;
  const observationsByDay = observations && observations.byDay;
  const observationsByHour = observations && observations.byHour;

  return (
    <Fragment>
      {!isEmpty(updatedAt) ? (
        <Row type="flex" justify="end">
          <Text disabled style={{ fontSize: "11px" }}>
            Updated: {moment(updatedAt).calendar()}
          </Text>{" "}
        </Row>
      ) : null}
      <Row type="flex" style={styles.overviewBar}>
        <Col xl={8} lg={8} xs={24}>
          <Card
            style={{ height: "10em", borderRight: 0, borderTop: 0 }}
            bodyStyle={{
              borderLeft: 0,
              paddingRight: "1rem",
              paddingLeft: "1rem",
            }}
          >
            <div style={styles.title}>
              <KPITitleText text={"Walk Ins"} />
            </div>
            <KpiSubText text={formatWholeNumberNaN(walkInsCount)} />
          </Card>
        </Col>
        <Col xl={8} lg={8} xs={24}>
          <Card
            style={{ height: "10em", borderRight: 0, borderTop: 0 }}
            bodyStyle={{
              borderLeft: 0,
              paddingRight: "1rem",
              paddingLeft: "1rem",
            }}
          >
            <div style={styles.title}>
              <KPITitleText text={"Observations"} />
            </div>
            <KpiSubText
              text={formatWholeNumberNaN(nonUniqueObservationsCount)}
            />
          </Card>
        </Col>
        <Col xl={8} lg={8} xs={24}>
          <Card
            style={{ height: "10em", borderRight: 0, borderTop: 0 }}
            bodyStyle={{
              borderLeft: 0,
              paddingRight: "1rem",
              paddingLeft: "1rem",
            }}
          >
            <div style={styles.title}>
              <KPITitleText text={"Unique Observations"} />
            </div>
            <KpiSubText text={formatWholeNumberNaN(uniqueObservationsCount)} />
          </Card>
        </Col>
      </Row>
      <div style={{ marginTop: "3%" }}>
        {!isEmpty(walkInsDayOfWeek) ||
        !isEmpty(walkInsFrequency) ||
        !isEmpty(walkInsHourOfDay) ? (
          <h2>Walk Ins</h2>
        ) : null}
        <Row gutter={30} style={{ marginTop: "2.5%" }}>
          {(!isEmpty(walkInsDayOfWeek) && (
            <Col xl={12} lg={12} xs={24}>
              <VisitByDayOfWeekCardV2
                geoDates={{
                  start: moment(geoStartDate),
                  end: moment(geoEndDate),
                }}
                data={walkInsDayOfWeek}
                fullDayName={true}
                showTotalVisits={false}
              />
            </Col>
          )) ||
            null}
          {(!isEmpty(walkInsFrequency) && (
            <Col xl={12} lg={12} xs={24}>
              <VisitByFrequencyCardV2
                geoDates={{
                  start: moment(geoStartDate),
                  end: moment(geoEndDate),
                }}
                data={walkInsFrequency}
              />
            </Col>
          )) ||
            null}
        </Row>
        {(!isEmpty(walkInsHourOfDay) && (
          <Row gutter={30} style={{ marginTop: "2%" }}>
            <Col xs={24}>
              <VisitByHourOfDayCardV2
                geoDates={{
                  start: moment(geoStartDate),
                  end: moment(geoEndDate),
                }}
                data={walkInsHourOfDay}
                showTotalVisits={false}
              />
            </Col>
          </Row>
        )) ||
          null}
      </div>
      <div style={{ marginTop: "3%" }}>
        {!isEmpty(observationsByDate) ||
        !isEmpty(observationsByDay) ||
        !isEmpty(observationsByHour) ? (
          <h2>Observations</h2>
        ) : null}
        {(!isEmpty(observationsByDate) && (
          <Row gutter={30} style={{ marginTop: "2.5%" }}>
            <Col xs={24}>
              <VisitByDateCardV2
                geoDates={{
                  start: moment(geoStartDate),
                  end: moment(geoEndDate),
                }}
                data={observationsByDate}
                total={uniqueObservationsCount}
                customLabel={"Unique Observations"}
              />
            </Col>
          </Row>
        )) ||
          null}
        {(!isEmpty(observationsByDay) && (
          <Row gutter={30} style={{ marginTop: "2%" }}>
            <Col xs={24}>
              <VisitByDayOfWeekCardV2
                geoDates={{
                  start: moment(geoStartDate),
                  end: moment(geoEndDate),
                }}
                data={observationsByDay}
                fullDayName={false}
                customLabel={"Unique Observations"}
              />
            </Col>
          </Row>
        )) ||
          null}
        {(!isEmpty(observationsByHour) && (
          <Row gutter={30} style={{ marginTop: "2%" }}>
            <Col xs={24}>
              <VisitByHourOfDayCardV2
                geoDates={{
                  start: moment(geoStartDate),
                  end: moment(geoEndDate),
                }}
                data={observationsByHour}
                customLabel={"Unique Observations"}
              />
            </Col>
          </Row>
        )) ||
          null}
      </div>
    </Fragment>
  );
};

export default AttributionReport;
